import * as React from "react";
const SvgFrame124 = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 17 18"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M4.056 8.15v-3.4c0-1.127.468-2.208 1.301-3.005A4.55 4.55 0 0 1 8.5.5a4.55 4.55 0 0 1 3.143 1.245 4.16 4.16 0 0 1 1.301 3.005v3.4m-10.666 0h12.444c.982 0 1.778.761 1.778 1.7v5.95c0 .939-.796 1.7-1.778 1.7H2.278C1.296 17.5.5 16.739.5 15.8V9.85c0-.939.796-1.7 1.778-1.7"
    />
  </svg>
);
export default SvgFrame124;
